import type { AddressFields } from "@/services/address-validation/address-validation.types";

export const formatAddressParagraph = (address: AddressFields): string =>
  [
    address.line1,
    address.line2,
    address.line3,
    address.city,
    address.county,
    address.state,
    address.zip,
    address.country,
  ]
    .filter((field) => field?.trim())
    .join(", ");
